import React from "react";
import styled from "styled-components";
import { apiClient } from "../App";
import { History } from "history";
import Button from "../components/Button";

const AUTH_URI = process.env.REACT_APP_AUTH_URI || "http://localhost:3100/auth";

interface Props {
  history: History;
}

const StyledLogin = styled.div`
  max-width: 400px;
  margin: 2rem auto;
`;

const Login: React.FC<Props> = ({ history }) => {
  let search = window.location.search;

  if (search.includes("?jwt=")) {
    const jwt = search.replace("?jwt=", "");
    apiClient.token = jwt;
    history.push("/recording");
  }

  return (
    <StyledLogin>
      <h1>Log Viewer</h1>
      <p>Welcome to Fruster Log Viewer. Press button below to login with your Google Account.</p>
      <Button title="Login" onClick={() => (window.location.href = AUTH_URI)} />
    </StyledLogin>
  );
};

export default Login;
